import { format, parseISO } from "date-fns";

import {
  BenefitTypeEnum,
  ItemStatusEnum,
} from "../../api/payments/items/domain/enum";

export function normalizeStatus(value) {
  return value ? String(value).toUpperCase() : ItemStatusEnum.INACTIVE;
}

export function normalizeBenefitType(value) {
  return value ? String(value).toUpperCase() : BenefitTypeEnum.CREDITS;
}

export const formatCreatedAt = (createdAt) => {
  if (!createdAt) {
    return "Sem data";
  }

  return format(parseISO(createdAt), "dd/MM/yyyy");
};

export const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

export const parseDisplayClient = (value) => {
  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "number") {
    return value === 1;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();

    return normalized === "true" || normalized === "1";
  }

  return false;
};

export const buildItemsQueryParams = ({
  page,
  limit,
  filterText,
  sortBy = "createdAt",
  sortOrder = "desc",
}) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    sortBy,
    sortOrder,
  });

  const normalizedFilterText = String(filterText || "").trim();

  if (normalizedFilterText) {
    params.append("filter", normalizedFilterText);
    params.append("search", normalizedFilterText);
    params.append("q", normalizedFilterText);
  }

  return params;
};

export const filterItemsByText = (items, filterText) => {
  const normalizedFilterText = String(filterText || "")
    .trim()
    .toLowerCase();

  if (!normalizedFilterText) {
    return items;
  }

  return items.filter((item) => {
    const searchableText = [
      item.name,
      item.code,
      item.value,
      item.statusType,
      item.saleType,
      item.display_client,
      item.createdAt,
      item.created_at,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return searchableText.includes(normalizedFilterText);
  });
};

export const sortByNewestFirst = (items) => {
  return [...items].sort((a, b) => {
    const dateA = new Date(
      a.createdAt || a.created_at || 0
    ).getTime();

    const dateB = new Date(
      b.createdAt || b.created_at || 0
    ).getTime();

    return dateB - dateA;
  });
};